import * as StatsActions from '../actions/StatsActions'

export interface ILeaderboardsState {
    results: Array<StatsActions.IUserRankingType>;
}

export interface IPlaysOverTimeState {
    results: Array<StatsActions.IDateValueStatisticsType>;
}

export interface IPlaysPerTimeOfDayState {
    results: Array<StatsActions.IDayHourValueStatisticsType>;
}

export interface IMaxDifficultyPassesOverTimeState {
    singlesMaxDifficultyPasses: Array<StatsActions.IMaxDifficultyPassStatisticsType>;
    doublesMaxDifficultyPasses: Array<StatsActions.IMaxDifficultyPassStatisticsType>;
}

export interface IPerYearLeaderboardsState {
    results: Array<StatsActions.IPerYearRankingsType>;
}

export interface IPerYearAndMonthLeaderboardsState {
    results: Array<StatsActions.IPerYearAndMonthRankingsType>;
}

export interface IRelationshipsLeaderboardsState {
    results: Array<StatsActions.IRelationshipRankingsType>;
}

export interface ISeasonsProgressState {
    results: Array<StatsActions.ISeasonProgressStatisticsType>;
}

export interface IRecommendedRivalsState extends StatsActions.IUserRecommendedRivalType {
}

export interface IUserNextScoresToTakeState {
    results: Array<StatsActions.IUserNextScoreToTakeType>;
}

export interface IPackProgressState {
    results: StatsActions.IPackProgressStatisticsType;
}

export interface ICountryLeaderboardsState {
    results: Array<StatsActions.ICountryRankingType>;
}

const initialLeaderboardState : ILeaderboardsState = {
    results: []
}

const initialPlaysOverTimeState : IPlaysOverTimeState = {
    results: []
}

const initialPlaysPerTimeOfDayState : IPlaysPerTimeOfDayState = {
    results: []
}

const initialPerYearLeaderboardState : IPerYearLeaderboardsState = {
    results: []
}

const initialPerYearAndMonthLeaderboardState : IPerYearAndMonthLeaderboardsState = {
    results: []
}

const initialMaxDifficultyPassesOverTimeState : IMaxDifficultyPassesOverTimeState = {
    singlesMaxDifficultyPasses: [],
    doublesMaxDifficultyPasses: [],
}

const initialRelationshipsLeaderboardState : IRelationshipsLeaderboardsState = {
    results: []
}

const initialSeasonsProgressState : ISeasonsProgressState = {
    results: []
}

const initialPackProgressState : IPackProgressState = {
    results: {
        packExternalId: "",
        packName: "",
        totalSinglesChartsCount: 0,
        totalDoublesChartsCount: 0,
        singlesChartsPurpleAwardCount: 0,
        doublesChartsPurpleAwardCount: 0,
        singlesChartsBlueAwardCount: 0,
        doublesChartsBlueAwardCount: 0,
        singlesChartsGreenAwardCount: 0,
        doublesChartsGreenAwardCount: 0,
        singlesChartsYellowAwardCount: 0,
        doublesChartsYellowAwardCount: 0,
        singlesChartsRedAwardCount: 0,
        doublesChartsRedAwardCount: 0,
    }
}

const initialRecommendedRivalsState : IRecommendedRivalsState = {
    difficultyRivalUserName: "",
    difficultyTimingRivalUserName: "",
    scoresDifficultyRivalUserName: "",
    scoresDifficultyTimingRivalUserName: "",
    scoresRivalUserName: "",
    scoresTimingRivalUserName: "",
    timingRivalUserName: "",
}

const initialUserNextScoresToTakeState : IUserNextScoresToTakeState = {
    results: []
}

const initialCountryLeaderboardState : ICountryLeaderboardsState = {
    results: []
}

export const topNNotechartArtistsLeaderboardReducer = (
    state: ILeaderboardsState = initialLeaderboardState,
    action: StatsActions.ILoadTopNNotechartArtistsLeaderboardSucceededAction): ILeaderboardsState => {
    switch (action.type) {
        case StatsActions.GET_TOP_N_NOTECHART_ARTISTS_LEADERBOARD_SUCCEEDED_ACTION_TYPE:
            return {
                results: [
                    ...action.json.results,
                ],
            }
        default:
            return state;
    }
}

export const topNPlaysLeaderboardReducer = (
    state: ILeaderboardsState = initialLeaderboardState,
    action: StatsActions.ILoadTopNPlaysLeaderboardSucceededAction): ILeaderboardsState => {
    switch (action.type) {
        case StatsActions.GET_TOP_N_PLAYS_LEADERBOARD_SUCCEEDED_ACTION_TYPE:
            return {
                results: [
                    ...action.json.results,
                ],
            }
        default:
            return state;
    }
}

export const topNScoresLeaderboardReducer = (
    state: ILeaderboardsState = initialLeaderboardState,
    action: StatsActions.ILoadTopNScoresLeaderboardSucceededAction): ILeaderboardsState => {
    switch (action.type) {
        case StatsActions.GET_TOP_N_SCORES_LEADERBOARD_SUCCEEDED_ACTION_TYPE:
            return {
                results: [
                    ...action.json.results,
                ],
            }
        default:
            return state;
    }
}

export const topNChartsPerYearLeaderboardReducer = (
    state: IPerYearLeaderboardsState = initialPerYearLeaderboardState,
    action: StatsActions.ILoadTopNChartsPerYearLeaderboardSucceededAction): IPerYearLeaderboardsState => {
    switch (action.type) {
        case StatsActions.GET_TOP_N_CHARTS_PER_YEAR_LEADERBOARD_SUCCEEDED_ACTION_TYPE:
            return {
                results: [
                    ...action.json.results,
                ],
            }
        default:
            return state;
    }
}

export const topNChartsPerYearAndMonthLeaderboardReducer = (
    state: IPerYearAndMonthLeaderboardsState = initialPerYearAndMonthLeaderboardState,
    action: StatsActions.ILoadTopNChartsPerYearAndMonthLeaderboardSucceededAction): IPerYearAndMonthLeaderboardsState => {
    switch (action.type) {
        case StatsActions.GET_TOP_N_CHARTS_PER_YEAR_AND_MONTH_LEADERBOARD_SUCCEEDED_ACTION_TYPE:
            return {
                results: [
                    ...action.json.results,
                ],
            }
        default:
            return state;
    }
}

export const topNSongsPerYearLeaderboardReducer = (
    state: IPerYearLeaderboardsState = initialPerYearLeaderboardState,
    action: StatsActions.ILoadTopNSongsPerYearLeaderboardSucceededAction): IPerYearLeaderboardsState => {
    switch (action.type) {
        case StatsActions.GET_TOP_N_SONGS_PER_YEAR_LEADERBOARD_SUCCEEDED_ACTION_TYPE:
            return {
                results: [
                    ...action.json.results,
                ],
            }
        default:
            return state;
    }
}

export const topNSongsPerYearAndMonthLeaderboardReducer = (
    state: IPerYearAndMonthLeaderboardsState = initialPerYearAndMonthLeaderboardState,
    action: StatsActions.ILoadTopNSongsPerYearAndMonthLeaderboardSucceededAction): IPerYearAndMonthLeaderboardsState => {
    switch (action.type) {
        case StatsActions.GET_TOP_N_SONGS_PER_YEAR_AND_MONTH_LEADERBOARD_SUCCEEDED_ACTION_TYPE:
            return {
                results: [
                    ...action.json.results,
                ],
            }
        default:
            return state;
    }
}

export const userPlaysOverTimeReducer = (
    state: IPlaysOverTimeState = initialPlaysOverTimeState,
    action: StatsActions.IGetUserPlaysOverTimeSucceededAction): IPlaysOverTimeState => {
    switch (action.type) {
        case StatsActions.GET_USER_PLAYS_OVER_TIME_SUCCEEDED_ACTION_TYPE:
            return {
                results: [
                    ...action.json.results,
                ],
            }
        default:
            return state;
    }
}

export const userPlaysPerTimeOfDayReducer = (
    state: IPlaysPerTimeOfDayState = initialPlaysPerTimeOfDayState,
    action: StatsActions.IGetUserPlaysPerTimeOfDaySucceededAction): IPlaysPerTimeOfDayState => {
    switch (action.type) {
        case StatsActions.GET_USER_PLAYS_PER_TIME_OF_DAY_SUCCEEDED_ACTION_TYPE:
            return {
                results: [
                    ...action.json.results,
                ],
            }
        default:
            return state;
    }
}

export const userMaxDifficultyPassesOverTimeReducer = (
    state: IMaxDifficultyPassesOverTimeState = initialMaxDifficultyPassesOverTimeState,
    action: StatsActions.IGetUserMaxDifficultyPassesOverTimeSucceededAction): IMaxDifficultyPassesOverTimeState => {
    switch (action.type) {
        case StatsActions.GET_USER_MAX_DIFFICULTY_PASSES_OVER_TIME_SUCCEEDED_ACTION_TYPE:
            return {
                singlesMaxDifficultyPasses: [
                    ...action.json.singlesMaxPassedResults,
                ],
                doublesMaxDifficultyPasses: [
                    ...action.json.doublesMaxPassedResults,
                ],
            }
        default:
            return state;
    }
}

export const userScoresTakenLeaderboardReducer = (
    state: IRelationshipsLeaderboardsState = initialRelationshipsLeaderboardState,
    action: StatsActions.ILoadUserScoresTakenLeaderboardSucceededAction): IRelationshipsLeaderboardsState => {
    switch (action.type) {
        case StatsActions.GET_USER_SCORES_TAKEN_LEADERBOARD_SUCCEEDED_ACTION_TYPE:
            return {
                results: [
                    ...action.json.results,
                ],
            }
        default:
            return state;
    }
}

export const userSeasonsProgressReducer = (
    state: ISeasonsProgressState = initialSeasonsProgressState,
    action: StatsActions.IGetUserSeasonsProgressSucceededAction): ISeasonsProgressState => {
    switch (action.type) {
        case StatsActions.GET_USER_SEASONS_PROGRESS_SUCCEEDED_ACTION_TYPE:
            return {
                results: [
                    ...action.json.results,
                ],
            }
        default:
            return state;
    }
}

export const userRecommendedRivalsReducer = (
    state: IRecommendedRivalsState = initialRecommendedRivalsState,
    action: StatsActions.IGetUserRecommendedRivalsSucceededAction): IRecommendedRivalsState => {
    switch (action.type) {
        case StatsActions.GET_USER_RECOMMENDED_RIVALS_SUCCEEDED_ACTION_TYPE:
            return {
                ...action.json,
            }
        default:
            return state;
    }
}

export const userNextScoresToTakeReducer = (
    state: IUserNextScoresToTakeState = initialUserNextScoresToTakeState,
    action: StatsActions.IGetUserNextScoresToTakeSucceededAction): IUserNextScoresToTakeState => {
    switch (action.type) {
        case StatsActions.GET_USER_NEXT_SCORES_TO_TAKE_SUCCEEDED_ACTION_TYPE:
            return {
                results: [
                    ...action.json.results,
                ],
            }
        default:
            return state;
    }
}

export const userPackProgressReducer = (
    state: IPackProgressState = initialPackProgressState,
    action: StatsActions.IGetUserPackProgressSucceededAction): IPackProgressState => {
    switch (action.type) {
        case StatsActions.GET_USER_PACK_PROGRESS_SUCCEEDED_ACTION_TYPE:
            return {
                results: {
                    ...action.json
                },
            }
        default:
            return state;
    }
}

export const topNPlaysPerCountryLeaderboardReducer = (
    state: ICountryLeaderboardsState = initialCountryLeaderboardState,
    action: StatsActions.ILoadTopNPlaysPerCountryLeaderboardSucceededAction): ICountryLeaderboardsState => {
    switch (action.type) {
        case StatsActions.GET_TOP_N_PLAYS_PER_COUNTRY_LEADERBOARD_SUCCEEDED_ACTION_TYPE:
            return {
                results: [
                    ...action.json.results,
                ],
            }
        default:
            return state;
    }
}